import { jsxs as n, jsx as i } from "react/jsx-runtime";
import { useMemo as S, useState as x, useEffect as g } from "react";
import { useMultiStyleConfig as C, Flex as $, VStack as v, HStack as w, Collapse as F, Center as O } from "@chakra-ui/react";
import k from "./FileListItemUploadProgress.mjs";
import { Typography as d } from "../../../../dataDisplay/Typography/Typography.mjs";
import { Button as D } from "../../../Button/Button.mjs";
import "../../../Button/IconButton.mjs";
import "../../../Button/ButtonGroup.mjs";
import { getFileUploadItemStatus as L, formatBytes as U } from "../../fileUploadFunctions.mjs";
import { SolarSystemIcon as j } from "../../../../icons/componentIcons.mjs";
const G = ({
  file: e,
  progressPercentage: l,
  abort: o,
  "data-testid": s,
  error: r,
  hideActionButton: f = !1,
  id: a,
  name: m,
  onRemoveFile: p
}) => {
  const h = C("FileUpload"), t = S(() => L(l, r), [l, r]), [y, u] = x(!0);
  return g(() => {
    let c;
    return t === "success" ? c = window.setTimeout(() => u(!1), 3e3) : u(!0), () => {
      c && clearTimeout(c);
    };
  }, [t]), /* @__PURE__ */ n($, { sx: h.listitem, id: a, "data-testid": s, role: "listitem", tabIndex: 0, children: [
    /* @__PURE__ */ n(v, { flex: 1, align: "stretch", spacing: 2, children: [
      /* @__PURE__ */ n(w, { spacing: 2, children: [
        /* @__PURE__ */ i(j, { variant: "light", size: "md" }),
        /* @__PURE__ */ i(d, { noOfLines: 1, variant: "bodySmall", as: "span", children: e.name }),
        /* @__PURE__ */ n(d, { color: "gray.600", variant: "bodySmall", as: "span", whiteSpace: "nowrap", children: [
          "(",
          U(e.size),
          ")"
        ] })
      ] }),
      /* @__PURE__ */ i(F, { in: y, animateOpacity: !0, children: /* @__PURE__ */ i(
        k,
        {
          id: a,
          "data-testid": s,
          file: e,
          progressPercentage: l,
          status: t,
          error: r
        }
      ) })
    ] }),
    p && !f && /* @__PURE__ */ i(O, { children: /* @__PURE__ */ i(
      D,
      {
        id: a && `${a}-action`,
        name: m && `${m}-action`,
        "data-testid": s && `${s}-action`,
        variant: "tertiary",
        onClick: () => {
          p(e), t === "uploading" && (o == null || o());
        },
        ...t === "success" && { isDestructive: !0 },
        "aria-label": t === "success" ? `Delete ${e.name}` : `Cancel ${e.name} upload`,
        children: t === "success" ? "Delete" : "Cancel"
      }
    ) })
  ] });
};
export {
  G as FileListItem
};
